<template>
  <div class="page-search">
    <search-header
      ref="search-header"
      :placeholder="placeholder"
      :searchkey.sync="searchKey"
      @enter="search(searchKey, null, 1)"
      clear="2"
    ></search-header>

    <div class="content">
      <template v-if="!searchKey">
        <div class="blank"></div>

        <div class="Ablock" v-if="historyList_show.length">
          <div class="title">
            {{$t('text.history')}}
            <img
              class="icon"
              @click="messageBoxInfo.show = true"
              src="@/assets/img/delete.png"
            />
          </div>

          <div class="items" ref="historyItems">
            <div
              class="item ellipsis"
              v-for="(item, index) in historyList_show"
              :key="index"
              @click="historyClick(item)"
            >
              {{ item }}
            </div>
            <div
              class="show-all"
              :class="[{ up: showAll }]"
              v-if="showIcon"
              @click="showAllHistory()"
            >
              <svg-icon icon-class="arrow"></svg-icon>
            </div>
          </div>
        </div>
      </template>

      <template v-else>
        <div class="key-items">
          <div
            class="item"
            v-for="(item, index) in results"
            :key="index"
            @click="resultClick(item)"
          >
            <svg-icon class="icon" icon-class="search3"></svg-icon>
            <span class="ellipsis">{{ item.title }}</span>
          </div>
        </div>
      </template>
    </div>

    <sd-message-box
        :info="messageBoxInfo"
        @confirm="deleteHistory(true)"
        @cancel="deleteHistory(false)"
        class="page-message"
        showCancel
    >
    </sd-message-box>
  </div>
</template>

<script>
import svgIcon from "../../components/svgIcon.vue";
import cache from "@/utils/cache";
export default {
  components: { svgIcon },
  name: "page-search",

  data() {
    return {
      messageBoxInfo: {
        show: false,
        text: this.$t('text.determine_all_historical_records')
      },
      pageType: "",

      searchKey: "",

      hiddenPop: false,
      showAll: false,
      showIcon: false,
      historyList_all: [],
      historyList_show: [],
      historyList_line: [],

      results: [],
      placeholder: this.$t('text.search_for_all')
    };
  },

  computed: {},

  watch: {
    searchKey(val) {
      if (val) {
        this.getData(val);
      }
    }
  },

  mounted() {
    let searchHeader = this.$refs["search-header"].$el;
    let input = searchHeader.getElementsByTagName("input")[0];
    input.focus();

    let history = cache.getLocal("caseHistory") || [];
    this.setHistory(history);
  },

  methods: {
    setHistory(history) {
      if (!history.length) return;
      this.historyList_all = history;
      this.historyList_show = JSON.parse(JSON.stringify(this.historyList_all));
      this.$nextTick(() => {
        if(!this.$refs.historyItems) return;
        let h = this.$refs.historyItems.offsetHeight;
        if (h > 128) {
          this.showIcon = true;
          this.setTwoLine(1);
        }
      });
    },

    setTwoLine(len) {
      this.historyList_show = this.historyList_all.slice(0, len);
      this.$nextTick(() => {
        let h = this.$refs.historyItems.offsetHeight;
        if (h <= 128) {
          len++;
          this.setTwoLine(len);
        } else {
          this.historyList_show = this.historyList_all.slice(0, len - 1);
          this.historyList_line = JSON.parse(
            JSON.stringify(this.historyList_show)
          );
        }
      });
    },

    showAllHistory() {
      if (this.showAll) {
        this.historyList_show = JSON.parse(
          JSON.stringify(this.historyList_line)
        );
      } else {
        this.historyList_show = JSON.parse(
          JSON.stringify(this.historyList_all)
        );
      }
      this.showAll = !this.showAll;
    },

    search(key = this.searchKey) {
      if (!key) {
        return this.$utils.message(this, this.$t('text.please_enter_content'));
      }
      let query = { key };
      if (key) {
        const index = this.historyList_all.findIndex(item => item===key);
        if (index >= 0) {
          this.historyList_all.splice(index, 1);
        }
        this.historyList_all.unshift(key);

        let history = cache.getLocal("caseHistory") || [];
        history = this.historyList_all;

        cache.setLocal("caseHistory", history);
      }


     this.$router.replace({
        path: "/search-case-result",
        query: {
          ...query
        }
      });
    },

    deleteHistory(flag) {
      this.messageBoxInfo.show = false;
      if (flag) {
        this.historyList_show = [];
        this.showIcon = false;
        cache.setLocal("caseHistory", []);
        this.$utils.message(this, this.$t('text.deleted'));
      }
    },

    getData(key) {
      this.$apis.school.getCourseList({searchTxt: key}).then(res => {
          this.results = res.data.list
          console.log(this.results);
      });
    },

    historyClick(item) {
      this.search(item);
    },

    resultClick(item) {
      this.search(item.title);
    }
  }
};
</script>

<style lang="scss" scoped>
.page-search {
  height: 100%;

  .search-header {

    /deep/ .input {
      flex: 1;
    }
    /deep/ {
      .project-input {
        width: 100%;

        input {
          height: 34px;
          font-size: 14px;
          line-height: 14px;
          padding-top: 10px;
          padding-bottom: 10px;
        }

        ::-webkit-input-placeholder {
          padding: 5px 0;
          // padding-top: 10px;
        }
      }

      .close {
        position: relative;
        top: -6px;
      }
    }
  }

  .content {
    height: calc(100% - 44px);
    overflow: auto;

    .blank {
      height: 24px;
    }

    .key-items {

      .item {
        height: 48px;
        display: flex;
        align-items: center;
        color: #484c54;
        font-size: 14px;
        text-align: left;
        border-bottom: 1px solid rgba(0, 0, 0, 0.05);

        .search3 {
          width: 20px;
          margin-left: 22px;
          margin-right: 8px;
        }

        span {
          flex: 1;
        }
      }
    }

  }

  .Ablock {
    margin-bottom: 32px;

    .title {
      font-size: 20px;
      line-height: 24px;
      font-weight: bold;
      padding: 0 16px;
      position: relative;
      text-align: left;

      .icon {
        position: absolute;
        width: 20px;
        height: 20px;
        right: 16px;
        top: 2px;
      }
    }

    .hidden-text {
      font-size: 14px;
      line-height: 16px;
      color: #aeb2b8;
      margin-top: 24px;
    }

    .items {
      padding: 0 16px;
      padding-right: 4px;
      display: flex;
      flex-wrap: wrap;

      .item {
        margin-top: 16px;
        line-height: 32px;
        padding: 0 12px;
        background-color: #f4f5f8;
        border-radius: 4px;
        font-size: 14px;
        width: fit-content;
        margin-right: 12px;
      }

      .show-all {
        width: 32px;
        height: 32px;
        margin-top: 16px;
        border-radius: 50%;
        background-color: #f4f5f8;

        .arrow {
          position: relative;
          bottom: 2px;
          width: 24px;
          color: #76787c;
        }

        &.up {
          transform: rotate(180deg);
        }
      }
    }
  }

}
</style>



// WEBPACK FOOTER //
// src/pages/school/search.vue